'use strict';
angular.module('weixinEditPageModule', ['weixinEditPageRouterModule']).controller('weixinEditPageCtrl', [
    '$scope',
    'beforeonload',
    '$timeout',
    'jsonArrayToStringService',
    'sensitiveWordCheckService',
    '$validation',
    '$filter',
    'modalDialog',
    'ueditorService',
    'initWeiXinDataService',
    '$compile',
    'editIsLock',
    'editingCenterService',
    'filterEditctrBtnsService',
    'wexinBtnService',
    'weixinService',
    'editcenterRightsService',
    'initeditctrBtnsService',
    '$q',
    'storageListenerService',
    '$element',
    'trsHttpService',
    '$state',
    'editPictureService',
    'editingMediatype',
    'weixinConst',
    'newMediaService',
    'messagePublishService',
    function (
        $scope,
        beforeonload,
        $timeout,
        jsonArrayToStringService,
        sensitiveWordCheckService,
        $validation,
        $filter,
        modalDialog,
        ueditorService,
        initWeiXinDataService,
        $compile,
        editIsLock,
        editingCenterService,
        filterEditctrBtnsService,
        wexinBtnService,
        weixinService,
        editcenterRightsService,
        initeditctrBtnsService,
        $q,
        storageListenerService,
        $element,
        trsHttpService,
        $state,
        editPictureService,
        editingMediatype,
        weixinConst,
        newMediaService,
        messagePublishService
    ) {
        initStatus();
        initData();
        weixinService.addFuture($scope, ['sendmessage']);
        
        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = {
                newsFormError: [],
                switch: 'manuscriptInfo', // 默认选中稿件信息
                channelId: $state.params.wxchannelid,
                chnldocid: $state.params.wxchnldocid,
                openBtn: true,
                isCheckSensitiveWords: false,
                zhengwen: false,
                support: {
                    content: '', // 提交给辅助写作的纯文本
                },
                hasTimeline: false, // 是否存在流程版本
                isEditDraft: !!angular.isDefined($state.params.wxchnldocid), // 是否会死编辑稿件
                bigFaceSwitch: { status: false },
                heimaCheckTit: '错别字校对',
                position: $state.params.wxplatform, // 稿件状态
                audioVideoidsArray: [], // 播放音视频临时数组
                isFusionEditor: $state.current.name == 'fusionnews', // 是否来自融合编辑器
                showVideoAudioDiv: false,
                attachFilePicSize: '100,100',
                topAttachFilePicSize: '235,100',
                isawaitrevise: !!$state.params.isawaitrevise, // 是否待修订
                mediaType: editingMediatype.weixin,
                wxmetadataid: $state.params.wxmetadataid,
                showError: false
            };
            $scope.data = {
                specialDoc: 0,
                userName: '',
                KEYWORDS: [],
                version: [],
                copyVersion: [],
                trench: weixinConst.listenStroageKey,
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                path: {
                    '-1': 'editingCenterFusionPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                errorMsg: [], //
            };
            if ($scope.status.isFusionEditor) {
                $scope.params = {
                    serviceid: 'mlf_fusionwechat',
                    methodname: 'getVirtualNewsDoc',
                    sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                };
            } else {
                $scope.params = {
                    serviceid: 'mlf_wechat',
                    MetaDataId: $state.params.wxmetadataid,
                    methodname: 'getNewsDoc',
                };
            }
            emitCloseWindow();
            $scope.editFlag = {
                media: 'weixin',
                docType: 'news',
            };
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            if (!$scope.status.isFusionEditor) {
                (angular.isDefined($state.params.wxchnldocid) ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
            // 融合编辑器下获取评审意见
            if ($state.params.iwometadataid) {
                getComment($state.params.iwometadataid, $scope.data.comment.currPage);
            }
            storageListenerService.removeListener('weixin');
        }

        /**
         * [initEditData description]初始化稿件新建
         *
         * @param  {[type]}  dealWithListFun   [dealWithListFun description]
         *
         * @return  {[type]}   [return description]
         */
        function initEditData(dealWithListFun) {
            var deffer = $q.defer();
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get')
                .then(function (data) {
                    $scope.list = data;
                    $scope.data.remarks = data.REMARKS;
                    document.title = data.TITLE;
                    $scope.list.TOPATTACHFILE = [];
                    initDocgenre(data);
                    initBtnArray();
                    initKeyWords();
                    reWriteImg($scope.list.ATTACHFILE);
                    if (!$state.params.iwometadataid) {
                        getComment($state.params.wxmetadataid, $scope.data.comment.currPage);
                    }
                    // 融合编辑器下处理list
                    if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                        dealWithListFun();
                    }
                    getVersion()
                        .then(function () {
                            return loadDirective();
                        })
                        .then(function () {
                            $scope.status.showVideoAudioDiv = true;
                            deffer.resolve();
                        });
                });
            // 稿件加锁
            editIsLock.lockDraft($state.params.wxmetadataid);
            return deffer.promise;
        }

        /**
         * [initNewData description]初始化稿件编辑
         *
         * @param  {[type]}  dealWithListFun   [dealWithListFun description]
         *
         * @return  {[type]}   [return description]
         */
        function initNewData(dealWithListFun) {
            var deffer = $q.defer();
            $scope.list = initWeiXinDataService.initNews();
            $scope.list.CHANNELID = $state.params.wxchannelid;
            $scope.list.ORIGINAL = '0';
            initKeyWords();
            initDocgenre();
            initBtnArray();
            // 融合编辑器下处理list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            loadDirective().then(function () {
                $scope.status.showVideoAudioDiv = true;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getAttachFileData description]初始化封面图
         *
         * @param  {[type]}  picData   [picData description]
         * @param  {[type]}  picType   [picType description]
         *
         * @return  {[type]}   [return description]
         */
        function getAttachFileData(picData, picType) {
            return [
                {
                    APPFILE: picData.imgName || picData.APPFILE,
                    APPDESC: picData.imgName || picData.APPDESC,
                    PERPICURL: picData.imgSrc || picData.PERPICURL,
                    TOPPIC: picType,
                },
            ];
        }

        /**
         * [getPicDataInit description]获取头条封面和非头条封面
         *
         * @param  {[type]}  picData   [picData description]
         *
         * @return  {[type]}   [return description]
         */
        function getPicDataInit(picData) {
            if ($scope.list.TOPATTACHFILE.length === 0) {
                $scope.list.TOPATTACHFILE = getAttachFileData(picData, '1');
            } else if ($scope.list.ATTACHFILE.length === 0) {
                $scope.list.ATTACHFILE = getAttachFileData(picData, '0');
            }
        }

        /**
     * [picCallbackData description] 点击获取封面图的回调
     * @return {[type]} [description]
     */
        $scope.picCallbackData = function () {
            var picresize;
            if ($scope.list.ATTACHFILE.length === 1 && $scope.list.TOPATTACHFILE.length === 1) {
                modalDialog.alertType('封面图已填充满', '', 'warning', 'confirm');
                return;
            }
            if ($scope.list.TOPATTACHFILE.length === 0) {
                picresize = $scope.status.topAttachFilePicSize;
            } else {
                picresize = $scope.status.attachFilePicSize;
            }
            return function (fileName) {
                editPictureService.newCropperApp(fileName, picresize).then(
                    function (src) {
                        getPicDataInit(src);
                    },
                    function () { }
                );
            };
        };

        /**
     * [loadDirective description] 加载异步指令
     * @return {[type]} [description]
     */
        function loadDirective() {
            var defer = $q.defer();
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            if ($state.params.issave === undefined || $state.params.issave === '0') {
                // 用于融合编辑器的虚拟表单校验，虚拟表单检验不需要加载编辑器
                LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                    var ueditor =
                        '<ueditor-for-weixin edit-flag="editFlag" versionid="data.lastVersionid" type="{{\'weixin\'}}"  callback="picCallbackData()" infullscreen="status.infullscreen" list="list" has-content="status.hasContent" is-fusion="status.isFusionEditor"></ueditor-for-weixin>';
                    ueditor = $compile(ueditor)($scope);
                    $element.find('ueditorLocation').append(ueditor);
                    var supportCreation =
                        '<support-creation is-trs-check-menu="{{\'true\'}}" parent-status="status" big-face-switch="status.bigFaceSwitch" has-editor="true" is-news="true" media-type="{{\'4\'}}" is-check-sensitive-words="status.isCheckSensitiveWords" list="list" not-allow-drag-video="true" not-allow-drag-audio="true"></support-creation>';
                    supportCreation = $compile(supportCreation)($scope);
                    $element.find('supportcreation').append(supportCreation);
                    defer.resolve();
                });
            } else {
                defer.resolve();
            }
            if (!$scope.status.isFusionEditor) {
                var draftList =
                    '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="wxNewsForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            }
            return defer.promise;
        }

        /**
        * [getSuggestions description]获取suggestion
        * @param  {[str]} viewValue [description]输入框内输入值
        * @return {[type]}           [description]
        */
        $scope.getSuggestions = function (viewValue) {
            return editingCenterService.getRecentUsageSources(viewValue);
        };

        /**
        * [deleteUploaderImg description]删除上传后的图片
        * @param  {[str]} attribute [description]要删除的属性
        * @return {[type]}           [description]
        */
        $scope.deleteUploaderImg = function (attribute) {
            $scope.list[attribute] = [];
        };

        /**
         * [initDocgenre description]初始化稿件体裁
         *
         * @param  {[type]}  obj   [obj description]
         *
         * @return  {[type]}   [return description]
         */
        function initDocgenre(obj) {
            var data = weixinService.initDocGenre();
            $scope.data.docGenre = data;
            $scope.list.DOCGENRE = angular.isDefined(obj) ? obj.DOCGENRE : angular.copy($scope.data.docGenre[0]);
        }

        /**
         * [reWriteImg description]回写图片列表数据
         *
         * @param  {[type]}  data   [data description]
         *
         * @return  {[type]}   [return description]
         */
        function reWriteImg(data) {
            var imgArray = angular.copy(data).map(function (value, index) {
                var obj = {
                    APPFILE: value.APPFILE,
                    APPDESC: value.APPDESC,
                    PERPICURL: value.PERPICURL,
                    TOPPIC: value.TOPPIC,
                };
                return obj;
            });
            if (imgArray.length > 0) {
                angular.forEach(imgArray, function (dataC, indexC) {
                    if (dataC.TOPPIC === '1') {
                        $scope.list.TOPATTACHFILE = [dataC];
                    } else {
                        $scope.list.ATTACHFILE = [dataC];
                    }
                });
            }
        }

        /**
         * [getVersion description]获取流程版本与操作日志
         *
         * @param  {[type]}  id   [id description]
         *
         * @return  {[type]}   [return description]
         */
        function getVersion(id) {
            var deferred = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $state.params.wxmetadataid;
            metadataid = $state.params.iwometadataid ? $state.params.iwometadataid : metadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(function (data) {
                $scope.data.version = data;
                $scope.page = data.page;
                $scope.data.copyVersion = data.copyArray;
                $scope.status.hasVersionTime = true;
                $scope.data.lastVersionid = data.lastVersionid;
                deferred.resolve();
            });
            return deferred.promise;
        }

        /**
     * [initBtnArray description] 初始化按钮
     * @return {[type]} [description]
     */
        function initBtnArray() {
            if ($scope.status.isFusionEditor) {return;}
            // 所需权限初始化
            $scope.wechatBtns = weixinService.initWechatBtns()[$state.params.wxplatform];
            // 查询权限方法
            $scope.methodArrary = ['wechat.daibian', 'wechat.daishen', 'wechat.yiqianfa'];
            initeditctrBtnsService
                .initWechatData($state.params.wxchannelid, $scope.methodArrary[$state.params.wxplatform])
                .then(function (data) {
                    $scope.dictionaryBtn = [
                        wexinBtnService.initWechatCompBtn(),
                        wexinBtnService.initWechatPenBtn(),
                        wexinBtnService.initWechatSignBtn(),
                    ];
                    initeditctrBtnsService.initBtns(data, $scope.dictionaryBtn[$state.params.wxplatform]).then((btns) => {
                        $scope.btnStatus = btns;
                        $scope.data.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.wechatBtns);
                        addBtn();
                    });
                    editcenterRightsService.initWeixinListBtn('wechat.trace', $state.params.wxchannelid).then(function (data) {
                        $scope.status.bigFaceRights = !!data['wechat.trace.chakan'] ? 'true' : 'false';
                    });
                });
        }

        /**
         * [enter description] 关键词回车事件
         * @return  {[type]}  [return description]
         */
        $scope.enter = function () {
            var reg = /^[^<>\/]*$/;
            if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                $scope.isShowKeywordTips = true;
            }
        };

        /**
         * [getKeywordsOrAbstract description]提取关键词或摘要
         * @param  {[str]} type [description]关键词类型或摘要
         * @return {[type]}      [description]
        */
        $scope.getKeywordsOrAbstract = function (type) {
            var content = ueditorService.bindContent();
            if (content === '') {
                modalDialog.alertType('请先填写稿件正文', '', 'warning', 'confirm');
                return;
            }
            $scope.loadingPromise = editingCenterService.getKeywordsOrAbstract(type, content).then(
                function (data) {
                    if (type === 'keywords') {
                        if (data !== '""') {
                            var arr = [];
                            var keywordsArray = data.substring(1, data.length - 1).split(';');
                            angular.forEach(keywordsArray, function (value, key) {
                                arr.push({
                                    name: value,
                                });
                            });
                            $scope.data.KEYWORDS = angular.isArray($scope.data.KEYWORDS) ? $scope.data.KEYWORDS : [];
                            $scope.data.KEYWORDS = $scope.data.KEYWORDS.concat(arr);
                            $scope.data.KEYWORDS = $filter('unique')($scope.data.KEYWORDS, 'name');
                            if ($scope.data.KEYWORDS.length > 10) {
                                $scope.data.KEYWORDS = $scope.data.KEYWORDS.splice(0, 10);
                            }
                        } else {
                            return;
                        }
                    }
                    if (type === 'abstract') {$scope.list.ABSTRACT = data.substring(1, data.length - 1);}
                },
                function (data) { }
            );
        };

        /**
         * [getCKMAbstract description]换成了资源中心抽取摘要的方式
         *
         * @return  {[type]}  [return description]
         */
        $scope.getCKMAbstract = function () {
            var content = ueditorService.bindContent();
            if (content === '') {
                modalDialog.alertType('请先填写稿件正文', '', 'warning', 'confirm');
                return;
            }
            var params = {
                typeid: 'zyzx',
                serviceid: 'ckmMark',
                modelId: 'mark',
                markContent: content,
                markType: 'abstract',
                isFilter: 'true',
                numOfAbs: 2
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                $scope.list.ABSTRACT = data.content[0].resultInfo;
            });
        };

        /**
     * [clearAllKeywords description]清空关键词
     * @return {[type]} [description]
     */
        $scope.clearAllKeywords = function () {
            $scope.data.KEYWORDS = [];
        };

        /**
     * [checkTag description] 标签检查
     * @param  {[type]} tag [description]
     * @return {[type]}     [description]
     */
        $scope.checkTag = function (tag) {
            var len = $scope.data.KEYWORDS.length;
            if (len == 10) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '关键词个数不能超过10个！';
                return false;
            } else {
                $scope.keywordsTips = '';
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(' ') > -1) {
                var spaceArr = tag.name.split(' ');
                $timeout(function () {
                    $scope.data.KEYWORDS.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.KEYWORDS.push({ name: spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };

        /**
     * [invalidTag description] 关键词非法事件
     * @param  {[type]} tag [description]
     * @return {[type]}     [description]
     */
        $scope.invalidTag = function (tag) {
            var reg = /^[^<>\/;]*$/;
            if (tag.name.length > 20) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '单个关键词长度不能超过20！';
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '不能包含特殊字符！';
            }
        };

        /**
     * [initKeyWords description] 初始化关键词
     * @return {[type]} [description]
     */
        function initKeyWords() {
            if (angular.isDefined($scope.list.KEYWORDS) && $scope.list.KEYWORDS !== '') {
                var KEYWORDS = $scope.list.KEYWORDS.split(';');
                $scope.data.KEYWORDS = [];
                angular.forEach(KEYWORDS, function (data, index, array) {
                    $scope.data.KEYWORDS.push({
                        name: data,
                    });
                });
            } else {
                $scope.data.KEYWORDS = [];
            }
        }

        /**
         * [addBtn description]增加按钮
         *
         * @return  {[type]}   [return description]
         */
        function addBtn() {
            var OPERDESC = ['保存', '保存', '保存'];
            var OPERFUN = ['save', 'save', 'save'];
            $scope.data.arrayBtn.unshift({
                RIGHTINDEX: 'save',
                OPERDESC: OPERDESC[$state.params.wxplatform],
                OPERNAME: '',
                OPERFUN: OPERFUN[$state.params.wxplatform],
            });

            /* $scope.data.arrayBtn.push({
                RIGHTINDEX: "close",
                OPERDESC: "关闭",
                OPERNAME: "",
                OPERFUN: "close"
            });*/
        }

        /**
     * [theFormError description] 获取表单变化
     * @return {[type]} [description]
     */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.wxNewsForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };

        /**
         * [getComment description]获取评审意见
         *
         * @param  {[type]}  id   [id description]
         * @param  {[type]}  currPage   [currPage description]
         *
         * @return  {[type]}   [return description]
         */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function (data) {
                $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                $scope.data.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
     * [getComment description]获取评审意见
     * @return {[type]} [description]
     */
        $scope.getLoadMoreComment = function () {
            $scope.data.comment.currPage += 1;
            getComment($state.params.wxmetadataid, $scope.data.comment.currPage);
        };

        /**
     * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
     * @return {[type]} [description]
     */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, { typeName: 'weixin', saveLocal: true });
        }

        /**
         * [saveContent description]
         *
         * @return  {[type]}   [return description]
         */
        function saveContent() {
            if ($scope.status.isFusionEditor) {
                return true;
            }
            ueditorService.saveContent($scope.list);
            // if ($scope.list.HTMLCONTENT.indexOf('images/video_default.png') > -1 || $scope.list.HTMLCONTENT.indexOf('static/audio_default.jpg') > -1 || $scope.list.HTMLCONTENT.indexOf('static/download_fail.png') > -1 || $scope.list.HTMLCONTENT.indexOf('static/jz.gif') > -1) {
            //     modalDialog.alertType('', '正文中有不符合发布要求的音视频或未成功下载的图片，请删除或替换后再尝试保存', 'error', false);
            //     return false;
            // } else {
            //     let outLinkCheckResults = ueditorService.checkLinksForWeixin($scope.list.HTMLCONTENT);
            //     if (outLinkCheckResults.ISSUCCESS === 'false') {
            //         outLinkCheckResults.REPORTS.forEach((item) => {
            //             let tmpURL = item.URL.replace(/&/gi, '&amp;');
            //             $scope.list.HTMLCONTENT = $scope.list.HTMLCONTENT.replace(item.URL, '');
            //             $scope.list.HTMLCONTENT = $scope.list.HTMLCONTENT.replace(tmpURL, '');
            //         });
            //         modalDialog.multiReportsAlert(outLinkCheckResults);
            //         return true;
            //     } 
            //     return true;
            // }
            return true;
        }

        /**
     * [manageSaveObjBeforeSave description] 保存前处理字段
     * @return {[type]} [description]
     */
        function manageSaveObjBeforeSave() {
            getKeyWords();
            var list = angular.copy($scope.list);
            // 处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined(list.FGD_AUTHINFO[0]) &&
                (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
            ) {
                list.FGD_AUTHINFO = [];
            }
            // 处理发稿单作者信息空数据提交问题
            // list.ATTACHFILE = angular.copy(jsonArrayToStringService.clearEmptyObjects(list.ATTACHFILE, "APPFILE"));
            // JSON对象数组转字符串
            list.SPECIALDOC = $scope.data.specialDoc;
            list.ORIGINALTYPE = $scope.data.originType;
            if ($scope.status.isFusionEditor) {
                delete list.ISNOPAYMENT;
                delete list.FGD_EDITINFO;
                delete list.FGD_AUTHINFO;
                delete list.DOCGENRE;
                list.METADATAID = $state.params.wxmetadataid || '0';
                list.serviceid = 'mlf_fusionwechat';
                list.methodname = 'saveVirtualNewsDoc';
                list.SourceDocId = $scope.data.sourceDocId || $state.params.iwometadataid;
            } else {
                list.serviceid = 'mlf_wechat';
                list.methodname = 'saveImgTextDoc';
            }
            list = jsonArrayToStringService.jsonArrayToString(list);
            return list;
        }

        /**
     * [manageDataAfterSave description]保存操作完成后进行数据处理
     * @param  {[type]} data [description]保存后的返回值
     * @param  {[type]} flag [description]调用保存服务后是否弹出成功窗口判断
     * @return {[type]}      [description]
     */
        function manageDataAfterSave(data, flag) {
            $scope.list.METADATAID = data.METADATAID;
            $scope.list.CHNLDOCID = data.CHNLDOCID;
            $state.params.wxchnldocid = $scope.list.CHNLDOCID;
            $state.params.wxmetadataid = $scope.list.METADATAID;
            storageListenerService.addListenerToWeixin('save');
            $scope.data.errorMsg = data.ERROR || [];
            if (flag) {
                if (!$scope.status.isFusionEditor) {
                    $state.transitionTo($state.current, $state.params, {
                        reload: false,
                    });
                    $timeout(function () {
                        if ($scope.data.errorMsg.length > 0) {
                            modalDialog.alertType('', '保存成功，但图片存在异常，请检查！', 'warning', false);
                        } else if (data.OUTLINKS) {
                            modalDialog.multiReportsAlert(data.OUTLINKS);
                        } else {
                            modalDialog.saveModel('保存成功', '', 'success');
                        }
                    }, 500);
                }
            } else {
                $scope.params = {
                    ChannelId: $state.params.wxchannelid,
                    ObjectIds: $state.params.chnldocid,
                    ChnlDocIds: $state.params.chnldocid,
                    MetaDataIds: $state.params.wxmetadataid,
                    serviceid: 'mlf_wechatoper',
                };
            }
        }

        /**
     * [getKeyWords description] 组装关键词开始
     * @return {[type]} [description]
     */
        function getKeyWords() {
            $scope.list.KEYWORDS = '';
            angular.forEach($scope.data.KEYWORDS, function (data, index, array) {
                if (index != $scope.data.KEYWORDS.length - 1) {
                    $scope.list.KEYWORDS += data.name + ';';
                } else {
                    $scope.list.KEYWORDS += data.name;
                }
            });
        }

        /**
         * [save description]保存
         *
         * @param  {[type]}  type   [type description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.save = function (type) {

            /* trsconfirm.sensitiveWords($state.params.chnldocid, function() {
                save(true);
            });*/
            // 包含本地版本功能的稿件类型做了特殊处理，在进行其他操作时均先做此保存操作，以此来更新本地版本
            type = angular.isDefined(type) ? type : true;
            // 如果新建不保存直接送审送签，则跳过保存的敏感词确认框
            // var chnldocid = type ? $state.params.wxchnldocid : true;
            var defer = $q.defer();
            save(type).then(
                function () {
                    if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'wxeditpage') {
                        var ue = UE.getEditor('ueditor');
                        if (type === true) {
                            editIsLock.lockDraft($state.params.wxmetadataid);
                        }
                        getVersion($scope.list.METADATAID);
                        var params;
                        if ($scope.status.isFusionEditor) {
                            params = {
                                serviceid: 'mlf_fusionwechat',
                                methodname: 'getVirtualNewsDoc',
                                sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                            };
                        } else {
                            params = {
                                serviceid: 'mlf_wechat',
                                methodname: 'getNewsDoc',
                                MetaDataId: $scope.list.METADATAID,
                            };
                        }
                        $scope.loadingPromise = trsHttpService
                            .httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                            .then(function (data) {
                                ue.ready(function () {
                                    ue.setContent(data.HTMLCONTENT);
                                    ueditorService.saveToLocal(
                                        $scope.list.METADATAID,
                                        'weixin',
                                        data.HTMLCONTENT,
                                        $scope.data.lastVersionid
                                    );
                                    // 新建稿件完成，加载查看痕迹按钮
                                    if (!$scope.status.isFusionEditor) {
                                        editcenterRightsService
                                            .initWeixinListBtn('wechat.trace', $state.params.wxchannelid)
                                            .then(function (data) {
                                                $scope.status.bigFaceRights = !!data['wechat.trace.chakan'] ? 'true' : 'false';
                                            });
                                    }
                                    defer.resolve();
                                });
                            });
                    } else {
                        getVersion($scope.list.METADATAID).then(function () {
                            ueditorService.saveToLocal(
                                $scope.list.METADATAID,
                                'weixin',
                                $scope.list.HTMLCONTENT,
                                $scope.data.lastVersionid
                            );
                        });
                        defer.resolve();
                    }
                },
                function () {
                    defer.reject({
                        plat: '微信'
                    });
                }
            );
            return defer.promise;
        };

        /**
         * [save description] 保存函数
         * @param   {[type]}  flag  [flag description]
         * @return  {[type]}        [return description]
         */
        function save(flag) {
            var deffer = $q.defer();
            if (!saveContent()) {
                deffer.reject();
                return deffer.promise;
            }
            $validation.validate($scope.wxNewsForm.authorForm);
            $validation
                .validate($scope.wxNewsForm)
                .success(function () {
                    modalDialog.isSecretInformation(
                        $state.params.wxmetadataid,
                        function () {
                            sensitiveWordCheckService.sensitiveWords($scope).then(function (sensitiveWords) {
                                $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                $scope.list.SENSITIVEWORDS = sensitiveWords;
                                if (angular.isDefined($scope.list.EXTPROPERTY)) {
                                    $scope.list.EXTPROPERTY.SENSITIVEWORDS = sensitiveWords;
                                } else {
                                    $scope.list.EXTPROPERTY = {
                                        SENSITIVEWORDS: sensitiveWords,
                                    };
                                }
                                $scope.wxNewsForm.$setPristine();
                                var list = manageSaveObjBeforeSave();
                                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                    function (data) {
                                        manageDataAfterSave(data, flag);
                                        beforeonload.refresh($scope);
                                        storageListenerService.addListenerToWeixin();
                                        deffer.resolve(data);
                                    },
                                    function (data) {
                                        deffer.reject(data);
                                    }
                                );
                            });
                        },
                        function () {
                            deffer.reject();
                        },
                        $scope.status.isFusionEditor
                    );
                })
                .error(function (msg) {
                    editingCenterService.checkSaveError($scope.wxNewsForm, $element, $scope); // 定位输入错的表单位置
                    deffer.reject(msg);
                });
            return deffer.promise;
        }

        /**
     * [weixinCompileSend description] 待编平台送审
     * @return {[type]} [description]
     */
        $scope.weixinCompileSend = function () {
            // $scope.save(false).then(function () {
            saveSend();
            // });
        };

        /**
         * [saveSend description]保存送审函数
         *
         * @return  {[type]}   [return description]
         */
        function saveSend() {
            newMediaService.trial($scope, weixinConst.trial).then((opinion) => {
                $scope.save(false).then(function () {
                    let toutiaoParams = angular.extend({
                        MetaDataIds: $state.params.wxmetadataid,
                        CurrChnlId: $state.params.wxchannelid,
                        opinion: opinion,
                    }, weixinConst.trial);
                    messagePublishService.publish('doEditPageOperation', toutiaoParams);
                });
            });
            // modalDialog.inputModel(
            //     '送审',
            //     '确定送审吗？',
            //     function (content) {
            //         var params = {
            //             serviceid: 'mlf_wechatoper',
            //             methodname: 'trialMetaDatas',
            //             MetaDataIds: $state.params.wxmetadataid,
            //             CurrChnlId: $state.params.wxchannelid,
            //             Opinion: content,
            //         };
            //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', false).then(
            //             function (data) {
            //                 modalDialog.alertType(
            //                     '送审成功',
            //                     '',
            //                     'success',
            //                     false,
            //                     function () {
            //                         storageListenerService.addListenerToWeixin();
            //                         window.close();
            //                     },
            //                     '',
            //                     1500
            //                 );
            //             },
            //             function () {
            //                 editIsLock.lockDraft($state.params.wxmetadataid);
            //             }
            //         );
            //     },
            //     '',
            //     function () {
            //         editIsLock.lockDraft($state.params.wxmetadataid);
            //     }
            // );
        }

        /**
     * [weixinCompileSignDirect description]
     * @return {[type]} [description]
     */
        $scope.weixinCompileSignDirect = function () {
            // $scope.save(false).then(function (data) {
            //     compileSign();
            // });
            compileSign();
        };

        /**
         * [compileSign description]待编平台直接送签函数
         *
         * @return  {[type]}   [return description]
         */
        function compileSign() {
            var array = [$scope.list];
            sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, $scope.data.mediaType).then(
                function () {
                    privateSingDirective(weixinConst.daibianSign);
                },
                function () {
                    // modalDialog.alertType(
                    //     '确认发送该稿件到待签平台？',
                    //     '',
                    //     'ask',
                    //     true,
                    //     function () {
                    privateSingDirective(weixinConst.daibianSign);
                    //     },
                    //     function () {
                    //         editIsLock.lockDraft($state.params.wxmetadataid);
                    //     }
                    // );
                }
            );

            /**
       * [privateCompileSign description]送签方法
       * @return {[type]} [description]
       */
            function privateCompileSign() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_wechatoper',
                    methodname: 'webDaiBianPublish',
                    ObjectIds: $state.params.wxchnldocid,
                    ChnlDocIds: $state.params.wxchnldocid,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(
                    function (data) {
                        modalDialog.alertType(
                            '直接送签成功',
                            '',
                            'success',
                            false,
                            function () {
                                deffer.resolve();
                                window.close();
                            },
                            '',
                            1500
                        );
                    },
                    function (result) {
                        issuedByForce(result, params).then(function () {
                            editIsLock.lockDraft($state.params.wxmetadataid);
                            deffer.resolve();
                        });
                    }
                );
                return deffer.promise;
            }
        }

        /**
         * [issuedByForce description] 强制签发
         *
         * @param  {[type]}  result   [params description]
         * @param  {[type]}  params   [params description]
         *
         * @return  {[type]}   [return description]
         */
        function issuedByForce(result, params) {
            var defer = $q.defer();
            var options = {
                params: params
            };
            editingCenterService.issuedByForce(result, options).then(function (result) {
                defer.resolve();
                if (result) {
                    window.close();
                }
            });
            return defer.promise;
        }

        /**
         * [signPush description]微信送签稿件需调推送接口
         *
         * @param  {[type]}  metaDataIds   [metaDataIds description]
         *
         * @return  {[type]}   [return description]
         */
        function signPush(metaDataIds) {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'sendDocToCloud',
                DocIds: metaDataIds,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                console.log('送签推送成功');
            });
        }

        /**
     * [weixinPendSignDirect description] 待审平台直接送签
     * @return {[type]} [description]
     */
        $scope.weixinPendSignDirect = function () {
            // $scope.save(false).then(function (data) {
            //     pendSign();
            // });
            pendSign();
        };

        /**
     * [pendSign description] 待审平台直接送签函数
     * @return {[type]} [description]
     */
        function pendSign() {
            var array = [$scope.list];
            sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, $scope.status.mediaType).then(
                function () {
                    privateSingDirective(weixinConst.daishenSign);
                },
                function () {
                    // modalDialog.alertType(
                    //     '确认发送该稿件到待签平台？',
                    //     '',
                    //     'ask',
                    //     true,
                    //     function () {
                    // storageListenerService.addListenerToWebsite('signed');
                    // privatePendSign(weixinConst.daishenSign).then(function () {
                    //     storageListenerService.addListenerToWeixin();
                    // });
                    privateSingDirective(weixinConst.daishenSign);
                    //     },
                    //     function () {
                    //         editIsLock.lockDraft($state.params.wxmetadataid);
                    //     }
                    // );
                }
            );

            /**
             * [privatePendSign description]
             *
             * @return  {[type]}   [return description]
             */
            function privatePendSign() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_wechatoper',
                    methodname: 'webDaiShenPublish',
                    ObjectIds: $state.params.wxchnldocid,
                    ChnlDocIds: $state.params.wxchnldocid,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(
                    function (data) {
                        modalDialog.alertType(
                            '直接送签成功',
                            '',
                            'success',
                            false,
                            function () {
                                deffer.resolve();
                                window.close();
                            },
                            '',
                            1500
                        );
                    },
                    function (result) {
                        issuedByForce(result, params).then(function () {
                            editIsLock.lockDraft($state.params.wxmetadataid);
                            deffer.resolve();
                        });
                    }
                );
                return deffer.promise;
            }
        }

        /**
     * [updateCKSelection description]trsCheckBox的回调函数
     * @param  {[str]} attribute [description]需要改变的属性
     * @return {[type]}           [description]
     */
        $scope.updateCKSelection = function (attribute) {
            $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
        };

        /**
     * [weixinPendrejectionDraft description] 待审平台撤稿
     * @return {[type]} [description]
     */
        $scope.weixinPendRejectionDraft = function () {
            // $scope.save(false).then(function (data) {
            rejectionDraft();
            // });
        };

        /**
     * [rejectionDraft description] 撤稿函数
     * @return {[type]} [description]
     */
        function rejectionDraft() {
            $scope.loadingPromise = newMediaService.rejection($scope, weixinConst.rejection).then((opinion) => {
                $scope.save(false).then(function () {
                    let toutParams = angular.extend(
                        {
                            ChannelId: $state.params.wxchannelid,
                            ChnlDocIds: $state.params.wxchnldocid,
                            opinion: opinion,
                        },
                        weixinConst.rejection
                    );
                    messagePublishService.publish('doEditPageOperation', toutParams);
                });
            });
            // modalDialog.inputModel(
            //     '撤稿',
            //     '撤稿原因(可选)',
            //     function (content) {
            //         var params = {
            //             serviceid: 'mlf_wechatoper',
            //             methodname: 'rejectionMetaDatas',
            //             ChannelId: $state.params.wxchannelid,
            //             Opinion: content,
            //             ChnlDocIds: $state.params.wxchnldocid,
            //         };
            //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', false).then(
            //             function (data) {
            //                 modalDialog.alertType(
            //                     '撤稿成功',
            //                     '',
            //                     'success',
            //                     false,
            //                     function () {
            //                         storageListenerService.addListenerToWeixin();
            //                         window.close();
            //                     },
            //                     '',
            //                     1500
            //                 );
            //             },
            //             function () {
            //                 editIsLock.lockDraft($state.params.wxmetadataid);
            //             }
            //         );
            //     },
            //     '',
            //     function () {
            //         editIsLock.lockDraft($state.params.wxmetadataid);
            //     }
            // );
        }

        /**
     * [savePublish description] 保存并送签
     * @return {[type]} [description]
     */
        $scope.savePublish = function () {
            // $scope.save(false).then(function (data) {
            //     signDirect(true);
            // });
            signDirect(true);
        };

        /**
         * [privateSingDirective description]
         * @param   {[type]}  method  [method description]
         * @return  {[type]}          [return description]
         */
        function privateSingDirective(method) {
            $scope.loadingPromise = newMediaService.sign($scope, '', function (params, array) {
                params.ObjectIds = params.ChnlDocIds = array.map(function (value, index) {
                    return value.DOC.CHNLDOCID;
                }).join(',');
            }
            ).then(function () {
                $scope.save(false).then(() => {
                    let signParams = angular.extend({
                        ObjectIds: $state.params.wxchnldocid,
                        ChnlDocIds: $state.params.wxchnldocid,
                    }, method);
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [signDirect description]已签发平台直接签发函数
         *
         * @param  {[type]}  isSaveAndPublish   [isSaveAndPublish description]
         *
         * @return  {[type]}   [return description]
         */
        function signDirect(isSaveAndPublish) {
            var array = [$scope.list];
            if (isSaveAndPublish) {
                privateSingDirective(weixinConst.yiqianfaSign);
                // mergeSign();
            } else {
                sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, $scope.status.mediaType).then(
                    function () {
                        privateSingDirective(weixinConst.yiqianfaSign);
                    },
                    function () {
                        privateSingDirective(weixinConst.yiqianfaSign);
                        // mergeSign();
                    }
                );
            }

            /**
             * [privateSingDirective description]
             *
             * @return  {[type]}   [return description]
             */
            // function privateSingDirective(method) {
            //     $scope.loadingPromise = newMediaService.sign($scope, '', function(params, array) {
            //             params.ObjectIds = params.ChnlDocIds = array.map(function(value, index) {
            //                 return value.DOC.CHNLDOCID;
            //             }).join(',');
            //         }
            //     ).then(function() {
            //         $scope.save(false).then(() => {
            //             let signParams = angular.extend({
            //                 ObjectIds: $state.params.wxchnldocid,
            //                 ChnlDocIds: $state.params.wxchnldocid,
            //             }, method);
            //             messagePublishService.publish('doEditPageOperation', signParams);
            //         });
            //     });
            // var params = {
            //     serviceid: 'mlf_wechatoper',
            //     methodname: 'webYiQianPublish',
            //     ObjectIds: $state.params.wxchannelid,
            //     ChnlDocIds: $state.params.wxchnldocid,
            // };
            // $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', false).then(
            //     function (dataC) {
            //         modalDialog.alertType(
            //             '送签成功',
            //             '',
            //             'success',
            //             false,
            //             function () {
            //                 storageListenerService.addListenerToWeixin();
            //                 window.close();
            //             },
            //             '',
            //             1500
            //         );
            //     },
            //     function () {
            //         editIsLock.lockDraft($state.arams.wxmetadataid);
            //     }
            // );
            // }

            /**
             * [mergeSign description]
             *
             * @return  {[type]}   [return description]
             */
            function mergeSign() {
                modalDialog.alertType(
                    '',
                    '确认送签稿件?',
                    'ask',
                    true,
                    function () {
                        privateSingDirective(weixinConst.yiqianfaSign);
                    },
                    function () {
                        editIsLock.lockDraft($state.params.wxmetadataid);
                    }
                );
            }
        }

        /**
         * [openPersonalVersionTime description]流程版本
         *
         * @param  {[type]}  item   [item description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.openPersonalVersionTime = function (item) {
            var path = $scope.data.path[item.MEDIATYPE];
            var params = {};
            if ($scope.status.isFusionEditor) {
                geRelatedversion($state.params.iwometadataid, item.VERSIONNUM).then(function (data) {
                    params = {
                        // 融合
                        metadataid: $state.params.iwometadataid,
                        iwoobjectversionid: item.OBJECTVERSIONID,
                        wzobjectversionid: angular.isDefined(data.web) ? data.web.objversionId : '',
                        bzobjectversionid: angular.isDefined(data.paper) ? data.paper.objversionId : '',
                        appobjectversionid: angular.isDefined(data.app) ? data.app.objversionId : '',
                        wxobjectversionid: angular.isDefined(data.wechat) ? data.wechat.objversionId : '',
                        versionum: item.VERSIONNUM,
                    };
                    item.url = $state.href(path, params);
                });
            } else {
                if ($scope.data.versionName && $scope.data.versionName[item.MEDIATYPE]) {
                    var objName = $scope.data.versionName[item.MEDIATYPE];
                    params[objName] = item.OBJECTVERSIONID;
                    item.url = $state.href(path, params);
                }
            }

            /* var path = $scope.data.path[item.MEDIATYPE];
            var params = {
                wxobjectversionid: item.OBJECTVERSIONID,
                chnldocid: $state.params.wxchnldocid
            };
            var url = $state.href(path, params);
            item.url = url;*/
        };

        /**
     * [geRelatedversion description] 融合稿获取关联流程版本
     * @param  {[type]} MetaDataId [description]
     * @param  {[type]} num        [description]
     * @return {[type]}            [description]
     */
        function geRelatedversion(MetaDataId, num) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_fusionmyrelease',
                methodname: 'getObjversionByDoc',
                METADATAID: MetaDataId,
                VersionNum: num,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
     * [toggleEditor description] 切换编辑器显隐
     * @return {[type]} [description]
     */
        $scope.toggleEditor = function () {
            $scope.status.zhengwen = !$scope.status.zhengwen;
            if ($scope.status.zhengwen) {
                // 隐藏编辑器
                $('.body_manuscript_content').addClass('editorHidden');
            } else {
                $('.body_manuscript_content').removeClass('editorHidden');
            }
        };
        if ($scope.status.isFusionEditor) {

            /**
            * [pageCantEdit description] 已提交渠道编辑页不能编辑
            * @param  {[type]} type [description] 稿件信息或属性信息
            * @return {[type]}      [description]
            */
            $scope.pageCantEdit = function (type) {
                $timeout(function () {
                    if (type === 'manuscriptInfo') {
                        var manuHeight = $('.wx_manuscript_info').height();
                        var manuWidth = $('.wx_manuscript_info').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(manuHeight)
                            .width(manuWidth);
                        $('.app_manuscript_info').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    } else if (type === 'attrInfo') {
                        var attrHeight = $('.wx_attr_infoattrInfo').height();
                        var attrWidth = $('.wx_attr_infoattrInfo').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(attrHeight)
                            .width(attrWidth);
                        $('.wx_attr_infoattrInfo').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    }
                }, 300);
            };

            /**
             * [initData description] 合编辑器用到的初始化数据
             * @param   {[type]}  dealWithListFun  [dealWithListFun description]
             * @return  {[type]}                   [return description]
             */
            $scope.initData = function (dealWithListFun) {
                var defer = $q.defer();
                if (angular.isDefined($state.params.wxchnldocid)) {
                    initEditData(dealWithListFun).then(function () {
                        defer.resolve();
                    });
                } else {
                    initNewData(dealWithListFun).then(function () {
                        defer.resolve();
                    });
                }
                return defer.promise;
            };

            /**
             * [loadFgd description]
             * @return  {[type]}  [return description]
             */
            $scope.loadFgd = function () {
                var draftList =
                    '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                    '<editor-auth-dir originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" author="list.FGD_AUTHINFO"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            };
        }

        /**
         * [revise description] 修订方法
         * @return  {[type]}  [return description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                $scope.save(false).then(function (data) {
                    var params = {
                        serviceid: 'mlf_modifydoc',
                        methodname: 'paperModifyDocsFinished',
                        PaperDocIds: $state.params.wxmetadataid,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(
                        function (data) {
                            modalDialog.alertType('修订成功', '', 'success', false, function () { });
                            storageListenerService.addListenerToWeixin('revise');
                            $timeout(function () {
                                window.close();
                            }, 2000);
                        },
                        function (data) {
                            modalDialog.alertType('修订失败', data.message, 'error', 'confirm', function () {
                                storageListenerService.addListenerToWeixin('revise');
                                window.close();
                            });
                        }
                    );
                });
            });
        };

        /**
         * [closeWindow description] 关闭窗口
         * @return  {[type]}  [return description]
         */
        $scope.closeWindow = function () {
            editingCenterService.closeWindow('app', $scope);
        };

        /**
         * [saveAndClose description] 保存内容并关闭窗口
         * @return  {[type]}  [return description]
         */
        $scope.saveAndClose = function () {
            $scope.save(false).then(function () {
                window.close();
            });
        };
    },
]);
